import api from './utils/api';

class ModelService {
  async findAll() {
    return api.get('/models');
  }

  async findById(id) {
    const result = await api.get(`/models/${id}`);
    return result.data;
  }

  async findByIdCity(id) {
    const result = await api.get(`/models/city/${id}`);
    return result.data;
  }

  async findByGender({
    gender,
    page,
    cityId,
    filters = [],
    minPrice = null,
    maxPrice = null,
  }) {
    const params = new URLSearchParams({
      gender,
      page: page.toString(),
    });

    if (minPrice !== null && minPrice !== '') {
      params.append('minPrice', minPrice.toString());
    }

    if (maxPrice !== null && maxPrice !== '') {
      params.append('maxPrice', maxPrice.toString());
    }

    if (filters && Array.isArray(filters) && filters.length > 0) {
      filters.forEach((filter) => {
        const [uuid, value] = filter.split(/-(?=[^-]+$)/);

        params.append(uuid, value);
      });
    }

    const result = await api.get(
      `/models/gender/${cityId}?${params.toString()}`
    );
    return result.data;
  }

  async findFullModel(id) {
    const result = await api.get(`/models/full/${id}`);
    return result.data;
  }

  async findDateAndVerification(id) {
    const result = await api.get(`/models/verification/${id}`);
    return result.data;
  }

  async findTopModel(id) {
    const result = await api.get(`/models/top/${id}`);
    return result.data;
  }

  async findAboutsModel(id) {
    const result = await api.get(`/models/abouts/${id}`);
    return result.data;
  }

  async findAboutsSectionModel(id, section) {
    const result = await api.get(`/models/find-abouts/${id}`, {
      params: { section },
    });

    return result.data;
  }

  async findReviewsModel(id) {
    const result = await api.get(`/models/reviews/${id}`);
    return result.data;
  }

  async findServicesModel(id) {
    const result = await api.get(`/models/services/${id}`);
    return result.data;
  }

  async findHeaderModel(id) {
    const result = await api.get(`/models/header/${id}`);
    return result.data;
  }

  async findInfoModel(id) {
    const result = await api.get(`/models/info/${id}`);
    return result.data;
  }

  async findPlanModel(id) {
    const result = await api.get(`/models/plan/${id}`);
    const { data } = result;

    // Garantir que sempre retorna um objeto válido
    if (!data || typeof data !== 'object') {
      console.error('ModelService.findPlanModel: API retornou formato inesperado:', data);
      return {};
    }

    return data;
  }

  async completeMeta({ gender, name, dateOfBirth }) {
    return api.put('/models/complete', { gender, name, dateOfBirth });
  }

  async descriptionMeta(data) {
    return api.put('/models/description', data);
  }

  async modelGetWord(id) {
    const result = await api.get(`/models/work/${id}`);
    return result.data;
  }

  async modelWord(data) {
    return api.put('/models/work', data);
  }

  async updatePlan({ planId }) {
    return api.put('/plans/update/update', { planId });
  }

  async updateUpgrade({ upgradeId }) {
    return api.post('/upgrade', { upgradeId });
  }

  async addChama(upgradeId) {
    return api.post('/model-upgrades', { upgradeId });
  }

  async visitsModel(modelId) {
    return api.post('/models/visits', { modelId });
  }

  async followerModel(modelId) {
    const { data } = await api.get(`/models/access/follower/${modelId}`);
    return data.isFollower;
  }

  async followModel(modelId) {
    const follow = await api.post(`/models/follower`, { modelId });
    return follow.data;
  }

  async updateModelPlan(data) {
    return api.put('/models/updateplan', data);
  }

  async findAllModels() {
    const result = await api.get('/models/access/access');
    return result.data;
  }

  async verificationModel(data) {
    const result = await api.post('/models/verification', data);
    return result.data;
  }

  async accessModel(data) {
    const result = await api.post('/models/access', data);
    return result.data;
  }
}

export default new ModelService();
